import { UnstyledButton } from '@chilipiper/design-system/src/new'
import { styled } from '@chilipiper/design-system'

export const StyledHoverButton = styled(UnstyledButton)`
  width: 100%;
  &:hover {
    background-color: ${({ theme }) => theme.colors['bg/list-item-hovered']};
  }
`
